import { graphql } from '../gql';

export const getCalendarEventsList = graphql(`
  query GetCalendarEventsList(
    $startTimeAfter: ISO8601DateTime
    $startTimeBefore: ISO8601DateTime
    $vendorIds: [ID!]!
  ) {
    searchEventVendors(
      input: {
        startTimeAfter: $startTimeAfter
        startTimeBefore: $startTimeBefore
        vendorIds: $vendorIds
        eventStatuses: [SCHEDULED, ACTIVE, IN_PROGRESS, COMPLETE, FINAL]
        perspective: RESTAURANT
        vendorStatuses: [ACTIVE]
      }
    ) {
      error {
        code
        message
      }
      eventVendors(first: 500) {
        nodes {
          __typename
          id
          productType
          ... on PopupEventVendor {
            confirmed
            siteDirectionsEmailSent
            vendor {
              id
              internalName
            }
            popupEvent {
              id
              startTime: eventStartTime
              endTime: eventEndTime
              status
              account {
                id
                name
              }
            }
            eventLocation {
              id
              setupTime
              serviceStartTime
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
                cafeLocation {
                  id
                  name
                }
              }
            }
          }
          ... on SelectEventVendor {
            aggregateManifestKey
            foodDelivered
            vendor {
              id
              internalName
            }
            preManifestDocument {
              id
              documentUrl
              status
              confirmationUrl
              manifestDate
            }
            finalManifestDocument {
              id
              documentUrl
              status
              confirmationUrl
              manifestDate
            }
            selectEvent {
              id
              startTime: endTime
              endTime: deliveryTime
              status
              readyAndBaggedTime
              mealPeriod
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
              }
            }
          }
          ... on CateringEventVendor {
            vendor {
              id
              internalName
            }
            event {
              id
              startTime
              endTime
              status
              name
              mealPeriod
              setupTime
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
